import { render, staticRenderFns } from "./DisclaimerForbidden.vue?vue&type=template&id=077a6f61&scoped=true&"
import script from "./DisclaimerForbidden.vue?vue&type=script&lang=js&"
export * from "./DisclaimerForbidden.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerForbidden.vue?vue&type=style&index=0&id=077a6f61&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a6f61",
  null
  
)

export default component.exports